import React, { PropTypes } from 'react';
import { hashHistory } from 'react-router'
import { inject, observer } from "mobx-react";
import { observable, action, toJS } from 'mobx';
import LeafletMap from "../../LeafletMap";
import { getCenter } from "../../../components/Map/getCenterLatLng";
import Spinner from '../../Spinner';
import DataFilter from '../../StationFilter';

@inject('tagStore', 'mapStore', 'parameterStore', 'hydroMeteoStore', 'stationStore', 'locationStore', 'locationTypeStore')
@observer
export default class HydrologygraphMap extends React.Component {

  static contextTypes = {
    notify: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired
  };
  map;

  constructor(props) {
    super(props);
    this.state = {
      selectedStationIds: [],
    };
  }

  @observable selectedMarker = null;
  @observable markers = [];
  @action onMarkerOver = marker => this.selectedMarker = marker.station_id;
  @action onChangeSelectedStations = items => {
    this.selectedStations = items;
  }

  onMarkerClick(marker) {
    // let stationId = marker.id.split('-')[1];
    hashHistory.push(`/analysis/hydrology/map/${marker.station_id}`)

  };

  handleSelectedStationIdsChange = (selectedStationIds) => {
    this.setState({ selectedStationIds });
  }

  applyFilters(markers) {
    const { selectedStationIds } = this.state;
    return selectedStationIds.length > 0 ? markers.filter((item) => selectedStationIds.includes(item.station_id)) : [];
  }
  
  
  getPopupBox = marker => {
    if (!marker) {
      return null;
    }
    let station = this.props.stationStore.findById(marker.station_id);
    let district = station.meta_data.find(item => item.name.trim() === 'District');
    let division = station.meta_data.find(item => item.name.trim() === 'Division');
    let subDivision = station.meta_data.find(item => item.name.trim() === 'Sub-Division');
    let ffwcIdentifier = station.meta_data.find(item => item.name.trim() === 'ffwc_Identifier');
    let upazila = station.meta_data.find(item => item.name.trim() === 'Upazila');
    let river = station.meta_data.find(item => item.name.trim() === 'River');
    let dangerLevel = station.meta_data.find(item => item.name.trim() === 'Danger Level');
    // let sensorRLValue = station.meta_data.find(item => item.name.trim() === 'Sensor RL Value (m)');
    const name = marker.station_name.replace(/ *\([^)]*\) */g, "")
    return (
      <div id={'station_marker-' + marker.id + '-popup'} style={{ maxHeight: '500px' }}>
        <div style={{ fontSize: '15px', fontWeight: 'bold' }}>{marker.station.name}</div>
        <span className="fa fa-close" style={{ position: 'absolute', right: 2, top: 2 }} onClick={() => this.selectedMarker = null} />
        <br />
        <div className='DataTable'>
          <table>
            <tbody>
              <tr><th>District</th><td>{!!district ? district.value : '-'}</td></tr>
              <tr><th>Division</th><td>{!!division ? division.value : '-'}</td></tr>
              <tr><th>Sub Division</th><td>{!!subDivision ? subDivision.value : '-'}</td></tr>
              <tr><th>FFWC Identifier</th><td>{!!ffwcIdentifier ? ffwcIdentifier.value : '-'}</td></tr>
              <tr><th>Upazila</th><td>{!!upazila ? upazila.value : '-'}</td></tr>
              <tr><th>River</th><td>{!!river ? river.value : '-'}</td></tr>
              <tr><th>Sensor RL Value</th><td>{!!marker.stage_15M ? marker.stage_15M.value : '-'}</td></tr>
              <tr><th>Danger Level</th><td>{!!dangerLevel ? dangerLevel.value : '-'}</td></tr>
            </tbody>
          </table>
        </div>
        <div className='full-width flex flex-row justify-center'>
          <button className='button' onClick={() => this.onMarkerClick(marker)}>Hydrograph</button>
        </div>
      </div>
    );
  };


  render() {
    const { mapStore, hydroMeteoStore, stationStore } = this.props;

    if (mapStore.loadingMarkers || stationStore.isLoading) return <Spinner />;

    let markers = toJS(hydroMeteoStore.hydrologyMarkers);
    markers = this.applyFilters(markers);
    const mapCenter = getCenter(markers)

    return (
      <div>
        <DataFilter onSelectedStationIdsChange={this.handleSelectedStationIdsChange}/>
        <div className='inline-grid'>
          <div className='flex-grow' style={{ minWidth: '300px' }}>


            <LeafletMap
              id='hydrology_map'
              markers={markers}
              center={mapCenter}
              onMarkerOver={this.onMarkerOver}
              onMarkerClick={this.onMarkerClick}
              height='55vh'
              isLoading={mapStore.loadingMarkers}
            >
              {this.selectedMarker ? <div className='map-info-box'>{this.getPopupBox(markers.find(item => +item.station_id === +this.selectedMarker))}</div> : null}
            </LeafletMap>
          </div>

          <div className='side-table'>
            <div className='bordered'>
              <div className='DataTable'>
                <table>
                  <caption>Markers Indicators</caption>
                  <tbody>
                    {hydroMeteoStore.waterlevelRange.map((item, i) => <tr key={`water-level-map-marker-indicator-${i}`}>
                      <th><i className='fa fa-circle' style={{ color: item.color }} /></th>
                      <td width={300}>{item.label}</td>
                    </tr>)}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Analysis/Hydrology/HydrologyMap.js